module.exports = __webpack_public_path__ + "img/file-pen.1abe3b91.svg";